import { render, staticRenderFns } from "./CapturarFotosDoc.vue?vue&type=template&id=748a0680&scoped=true&"
import script from "./CapturarFotosDoc.vue?vue&type=script&lang=js&"
export * from "./CapturarFotosDoc.vue?vue&type=script&lang=js&"
import style0 from "./CapturarFotosDoc.vue?vue&type=style&index=0&id=748a0680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748a0680",
  null
  
)

export default component.exports